import { createSelector } from 'reselect';
import { userRoles } from '../../../shared/authorization';
import { userRoleSelector } from '../../../shared/store/selectors';
import { YesNoFlag } from '@common/constants/sharedConstants';

export const fetchTagsErrorSelector = ({ administration }) =>
  administration.categoriesAndTags.fetchTagsError;

export const fetchTagsLoadingSelector = ({ administration }) =>
  administration.categoriesAndTags.tagsLoading;

export const fetchSubTagsErrorSelector = ({ administration }) =>
  administration.categoriesAndTags.fetchSubTagsError;

export const fetchSubTagsLoadingSelector = ({ administration }) =>
  administration.categoriesAndTags.subTagsLoading;

export const categoriesOptionsSelector = createSelector(
  state => state.administration.categoriesAndTags,
  categoriesAndTags => categoriesAndTags.categoriesList.map(({ description, categoryName }) => ({
    value: categoryName,
    label: description,
  }))
);

export const selectedCategorySelector = ({ administration }) =>
  administration.categoriesAndTags.categoriesList.find(category =>
    category.categoryName === administration.categoriesAndTags.category
  ) ?? null;
export const canModifyCurrentCategory = createSelector(
  selectedCategorySelector,
  userRoleSelector,
  (category, role) => role === userRoles.SUPER_USER || category?.userEditableFlag === YesNoFlag.Y
);

export const tagsListSelector = ({ administration }) =>
  administration.categoriesAndTags.tagsList;

export const subTagsListSelector = createSelector(
  state => state.administration.categoriesAndTags.subTagsList,
  subTagList => subTagList
    .map(({ tagName, description }) => ({
      value: tagName,
      label: description,
    }))
);

export const isSavingTagInProgressSelector = ({ administration }) =>
  administration.categoriesAndTags.isSavingTagInProgress;

export const defaultTagSelector = createSelector(
  state => state.administration.categoriesAndTags.tagsList,
  tagList => tagList
    .map(({ tagName, description }) => ({
      value: tagName,
      label: description,
    }))
);

export const catViewSelector = ({ administration }) =>
  administration.categoriesAndTags.categoryViews
    .map(catView =>
      ({
        value: catView.value,
        label: catView.name,
      })
    );

export const canSeeAdditionalColumnsSelector = createSelector(
  userRoleSelector,
  role => role === userRoles.SUPER_USER
);

export const isUploadingTagsSelector = ({ administration }) =>
  administration.categoriesAndTags.isUploadingTags;

export const isImportingTagsSelector = ({ administration }) =>
  administration.categoriesAndTags.isImportingTags;

export const uploadedTagsSelector = ({ administration }) =>
  administration.categoriesAndTags.uploadedTags;

export const areImportsPendingSelector = createSelector(
  uploadedTagsSelector,
  uploadedTagEntities => !(uploadedTagEntities.some(({ validationData }) => !!validationData)
    || uploadedTagEntities.length === 0));

export const isDeletingTagInProgressSelector = ({ administration }) =>
  administration.categoriesAndTags.isDeletingTagInProgress;

export const isSavingCategoriesInProgressSelector = ({ administration }) =>
  administration.categoriesAndTags.isSavingCategoriesInProgress;
